/**
 * Created by Ning Jiang on 7/5/2019.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {PixiesVsPiratesGameConfig} from "../../PixiesVsPiratesGameConfig";
import {TweenLite, TimelineLite, Back} from "gsap";

export class BattleCollectView extends BaseView {

    private readonly _collectorTime:number = 1;

    private _layer:ScalableLayer;

    constructor() {
        super();
        this._layer = StageManager.getLayer(PixiesVsPiratesGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
    }

    public playCollector(type:1 | 2, startPos:[number, number], endPos:[number, number], onCompleteCallback:() => void):TimelineLite {
        const collector:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(`collector${type.toString()}`)[0]);
        collector.blendMode = PIXI.BLEND_MODES.ADD;
        collector.anchor.set(0.5);
        collector.scale.set(1.5);
        collector.alpha = 0;
        collector.position.set(startPos[0], startPos[1]);
        this._layer.addChild(collector);

        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => collector.alpha = 1,
            TweenLite.to(collector, this._collectorTime, {x : endPos[0], ease : Back.easeInOut.config(2)}),
            TweenLite.to(collector, this._collectorTime, {y : endPos[1]})
        ]);
        timeline.add(() => {
            onCompleteCallback();
            TweenLite.to(collector, 0.1, {
                alpha : 0,
                onComplete : () => {
                    this._layer.removeChild(collector);
                    collector.destroy();
                }
            })
        });
        return timeline;
    }
}